import React from 'react'
import translate from '../../../utilities/translate'
import translations from './translations'
import PropTypes from 'prop-types'
import { getLocales } from '../../../utilities/locales'
import Truvid from '../../../components/Adverts/Adnimation/Truvid'
import Heading from '../../../widgets/Typography/Heading'
import Divider from '../../../widgets/Layout/Divider'
import styles from './MostPopular.module.css'

// trans :: String -> String -> String
const trans = translate(translations)

const MostPopular = ({ locale }) =>
  <div className={ styles.wrapper }>
    <Heading level="2">{ trans(locale)('title') }</Heading>
    <Truvid />
    <Divider variant="thin" visibility="none"/>
  </div>

MostPopular.propTypes = {
  locale: PropTypes.oneOf(getLocales()).isRequired,
}

export default MostPopular
